import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { skills } from '../data/portfolio';

const SkillCategory = ({ category, index }) => {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.1 });

  return (
    <div
      ref={ref}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(24px)',
        transition: `opacity 0.6s ease ${index * 80}ms, transform 0.6s ease ${index * 80}ms`,
      }}
    >
      <div
        className="section-label mb-4"
        style={{ paddingBottom: '8px', borderBottom: '1px solid var(--color-border)' }}
      >
        {category.category}
      </div>
      <div className="flex flex-wrap gap-2">
        {category.items.map((item) => (
          <span
            key={item}
            className="font-mono text-xs px-3 py-2 transition-all duration-200"
            style={{
              color: 'var(--color-text)',
              border: '1px solid var(--color-border)',
              background: 'var(--color-surface)',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = 'var(--color-accent)';
              e.currentTarget.style.color = 'var(--color-accent)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = 'var(--color-border)';
              e.currentTarget.style.color = 'var(--color-text)';
            }}
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  );
};

const Stack = () => {
  const { ref: headRef, isVisible: headVisible } = useScrollReveal({ threshold: 0.2 });

  return (
    <section
      id="stack"
      className="py-24 md:py-36"
      style={{ backgroundColor: 'var(--color-bg)', borderTop: '1px solid var(--color-border)' }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Header */}
        <div ref={headRef} className="mb-14 md:mb-20">
          <div
            className="section-label mb-6"
            style={{ opacity: headVisible ? 1 : 0, transition: 'opacity 0.5s ease' }}
          >
            04 / STACK
          </div>
          <h2
            className="font-bold leading-none tracking-tight"
            style={{
              fontSize: 'clamp(2.2rem, 6vw, 5rem)',
              opacity: headVisible ? 1 : 0,
              transform: headVisible ? 'translateY(0)' : 'translateY(24px)',
              transition: 'opacity 0.6s ease 0.1s, transform 0.6s ease 0.1s',
            }}
          >
            THE TOOLS
          </h2>
          <h2
            className="font-bold leading-none tracking-tight"
            style={{
              fontSize: 'clamp(2.2rem, 6vw, 5rem)',
              color: 'var(--color-text2)',
              opacity: headVisible ? 1 : 0,
              transform: headVisible ? 'translateY(0)' : 'translateY(24px)',
              transition: 'opacity 0.6s ease 0.2s, transform 0.6s ease 0.2s',
            }}
          >
            I BUILD WITH.
          </h2>
        </div>

        {/* Skills grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
          {skills.map((cat, i) => (
            <SkillCategory key={cat.slug} category={cat} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stack;
